/**
 * This is server side shim of the editor, we use storage in editor to
 * provide helpers etc that extensions etc use. When we render on server
 * we don't have full instance of editor so we use this to provide the
 * things we need to render stuff.
 */ import { _ as _define_property } from "@swc/helpers/_/_define_property";
class SsrEditor {
    setupEditor(externalRenderers) {
        this.storage['da-ext-renderers'] = externalRenderers;
    }
    constructor(){
        _define_property(this, "storage", {});
    }
}
export default new SsrEditor();

//# sourceMappingURL=SsrEditor.js.map